export default {
  setCurrentHash (state, hash) {
    state.currentHash = hash
  },
  setLatestHash (state, hash) {
    state.latestHash = hash
  },
  setUpdateAvailable (state, value) {
    state.updateAvailable = value
  },
  setPollHandle (state, handle) {
    state.pollHandle = handle
  }
}
